import React, { useMemo } from 'react';
import { InlineInputCardWrapper } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/shared';
import { SingleSelectInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/single-select-input';
import { TimeZones } from '@/features/editor/widgets/targeting/schedule-time-picker';

export interface GenericJsTimezoneInputProps {
  value: string;
  onChange: (value: string) => void;
}

const NULL_TIMEZONE_OPTION = { value: `local`, label: `Device local time` };

const TIMEZONE_OPTIONS = [
  NULL_TIMEZONE_OPTION,
  ...TimeZones.map((tz) => ({
    label: tz.label,
    value: `${tz.value.offset}`,
  })),
];

export function GenericJsTimezoneInput({
  value,
  onChange,
}: GenericJsTimezoneInputProps) {
  const selectedOption = useMemo(
    () =>
      TIMEZONE_OPTIONS.find((option) => option.value === value) ||
      NULL_TIMEZONE_OPTION,
    [value],
  );

  return (
    <InlineInputCardWrapper>
      <span>Timezone</span>
      <SingleSelectInput
        key={selectedOption.value}
        options={TIMEZONE_OPTIONS}
        onChange={(option) => onChange(String(option.value))}
        initialValue={selectedOption}
      />
    </InlineInputCardWrapper>
  );
}
